var map = {
	"./Весна.jpg": 18923,
	"./Зима.jpg": 29333,
	"./Космос.jpg": 3035,
	"./Лес.jpg": 27580,
	"./Лето.jpg": 17486,
	"./МоскваСити.jpg": 78230,
	"./Небо.jpg": 89262,
	"./Осень.jpg": 62602,
	"./Пляж.jpg": 79437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53875;